var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.1626,
    width: 18.6375,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3623,
    y: 16.7998,
    width: 18.6375,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 28.5249,
    width: 18.6375,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 16.7998,
    width: 6.65,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3501,
    y: 28.5249,
    width: 6.65,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3501,
    y: 5.1626,
    width: 6.65,
    height: 1.3125,
    rx: 0.65625,
    fill: "#979EA8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5513,
    y: 0.63875,
    width: 6.86,
    height: 10.4475,
    rx: 3.43,
    stroke: "#979EA8",
    strokeWidth: 1.2775
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.56355,
    y: 12.1886,
    width: 6.86,
    height: 10.4475,
    rx: 3.43,
    stroke: "#979EA8",
    strokeWidth: 1.2775
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5513,
    y: 23.9137,
    width: 6.86,
    height: 10.4475,
    rx: 3.43,
    stroke: "#979EA8",
    strokeWidth: 1.2775
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconMenu);
export default __webpack_public_path__ + "static/media/SettingsIcon_menu.af2004468a39fe3b140500160953b20d.svg";
export { ForwardRef as ReactComponent };